import { FC } from 'react'
import Grid from '@material-ui/core/Grid'

import { Typography, makeStyles, IconButton } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'

import MyTextfield from '../../../control/textfield/textfield'
import MyCheckbox from '../../../control/checkbox/checkbox'
import Button from '../../../control/button/button'

import useTitleName from '../../../services/um/lookups/useTitleName'
import useAcademicPosition from '../../../services/um/lookups/useAcademicPosition'
import { validateEmail, validateMobilePhone } from '../../../utilities/validate'
import { useForm } from 'react-final-form'
import Select from '../../../control/select/select'
import Tooltip from '../../../control/tooltip/tooltip'
import { InfoOutlined } from '@material-ui/icons'

interface InformationProps {
    handleSubmit: (values: any) => void
    position: string
    title: string
}
const Information: FC<InformationProps> = ({ handleSubmit, position, title }) => {
    const t = useTranslate()
    const { state: titleOptions } = useTitleName()
    const { state: positionOptions } = useAcademicPosition()
    const classes = useStyles()
    const form = useForm()

    const lang = t.languageStore.currentLanguage

    const onChangeTelePhone = (val: string) => {
        if (val) {
            form.change('telephone', val.replace(/[^\d]/g, '').slice(0, 20))
        }
    }

    const handleChangePosition = (val: string) => {
        if (val !== '6') {
            form.change('positionTH', null)
            form.change('positionEN', null)
        }
    }
    const handleChangeTitle = (val: string) => {
        if (val !== '5') {
            form.change('titleTH', null)
            form.change('titleEN', null)
        }
    }
    return (
        <Grid container>
            <Grid item xs={12} md={4}>
                <Typography variant="h6">{t.get('UM.PROFILE.PI_ADN_ACCOUNT')}</Typography>
                <Typography variant="caption">{t.get('UM.PROFILE.DATA_SHOW_ONSITE')}</Typography>
            </Grid>
            <Grid item xs={12} md={8}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="username"
                            materialInputProps={{
                                disabled: true,
                                label: `${t.get('UM.PROFILE.EMAIL')} (${t.get('UM.PROFILE.FOR_LOGIN')})`,
                                placeholder: `${t.get('UM.PROFILE.EMAIL')}`,
                                size: 'small',
                            }}
                            required={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="email"
                            materialInputProps={{
                                disabled: false,
                                label: `${t.get('UM.PROFILE.EMAIL')} (${t.get('UM.PROFILE.FOR_NEW_ALERT')})`,
                                placeholder: `${t.get('UM.PROFILE.EMAIL')}`,
                                size: 'small',
                            }}
                            validates={[validateEmail(t.get('MESSAGE.M017'))]}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Select
                            name="position"
                            option={[...positionOptions].map((item: any) => {
                                return {
                                    value: item.id.toString(),
                                    label: item[lang === 'th' ? 'name_th' : 'name_en'],
                                }
                            })}
                            label={t.get('UM.PROFILE.ACADEMIC_POSITION')}
                            placeholder={t.get('UM.PROFILE.ACADEMIC_POSITION')}
                            size="small"
                            defaultValue={[position]}
                            icon={
                                <Tooltip title={t.get('MESSAGE.M024', [t.get('UM.PROFILE.ACADEMIC_POSITION_DR')])}>
                                    <IconButton size="small">
                                        <InfoOutlined style={{ fontSize: '18px' }}></InfoOutlined>
                                    </IconButton>
                                </Tooltip>
                            }
                            onChangeSelect={handleChangePosition}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyTextfield
                            name="positionTH"
                            materialInputProps={{
                                disabled: position !== '6',
                                label: `${t.get('UM.PROFILE.POSITION_OTHER_TH')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyTextfield
                            name="positionEN"
                            materialInputProps={{
                                disabled: position !== '6',
                                label: `${t.get('UM.PROFILE.POSITION_OTHER_EN')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyCheckbox name="isPhD" label={t.get('UM.PROFILE.ACADEMIC_POSITION_DR')} />
                    </Grid>
                    <Grid item xs={12}>
                        <Select
                            name="title"
                            option={[...titleOptions].map((item: any) => ({
                                value: item.id.toString(),
                                label: item[lang === 'th' ? 'name_th' : 'name_en'],
                            }))}
                            label={t.get('UM.PROFILE.PREFIX')}
                            placeholder={t.get('UM.PROFILE.PREFIX')}
                            size="small"
                            defaultValue={[title]}
                            icon={
                                <Tooltip title={t.get('MESSAGE.M025')}>
                                    <IconButton size="small">
                                        <InfoOutlined style={{ fontSize: '18px' }}></InfoOutlined>
                                    </IconButton>
                                </Tooltip>
                            }
                            onChangeSelect={handleChangeTitle}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyTextfield
                            name="titleTH"
                            materialInputProps={{
                                disabled: title !== '5',
                                label: `${t.get('UM.PROFILE.PREFIX_OTHER_TH')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyTextfield
                            name="titleEN"
                            materialInputProps={{
                                disabled: title !== '5',
                                label: `${t.get('UM.PROFILE.PREFIX_OTHER_EN')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="nameTH"
                            materialInputProps={{
                                disabled: false,
                                label: `${t.get('UM.PROFILE.FULLNAME_TH')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="nameEN"
                            materialInputProps={{
                                disabled: false,
                                label: `${t.get('UM.PROFILE.FULLNAME_EN')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="telephone"
                            materialInputProps={{
                                disabled: false,
                                label: `${t.get('UM.PROFILE.CONTACT_NUMBER')}`,
                                size: 'small',
                            }}
                            handleValueChange={onChangeTelePhone}
                            validates={[validateMobilePhone(t.get('MESSAGE.M004'))]}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="departments"
                            materialInputProps={{
                                disabled: false,
                                label: `${t.get('UM.PROFILE.DEPARTMENT')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="departments_en"
                            materialInputProps={{
                                disabled: false,
                                label: `${t.get('UM.PROFILE.DEPARTMENT_EN')}`,
                                size: 'small',
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Button
                    size={'large'}
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    className={classes.saveButton}
                    style={{ minWidth: '0px' }}
                >
                    {t.get('BUTTON.SAVE')}
                </Button>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    saveButton: {
        border: 'solid 1px #db5f8e',
        float: 'right',
    },
}))
export default Information
